<template>
    <v-container class="fill-height">
        <v-row justify="center" align="center">
            <v-form>
                <v-card min-width="300" elevation="0" color="transparent" >
                    <v-card-text>
                        <v-text-field
                                class="mb-2"
                                label="E-Mail"
                                required
                                outlined
                                v-model="email"
                                autofocus
                                hide-details
                                autocomplete="username"
                        />
                        <v-text-field
                                label="Password"
                                type="password"
                                required
                                outlined
                                autocomplete="current-password"
                                v-model="password"
                                @keyup.enter="login"
                                hide-details
                        />
                    </v-card-text>
                    <v-card-actions class="pr-4 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="login()">Lass mich ein</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-row>
        <v-snackbar
                v-model="showError"
                color="error"
                :timeout=errorTimeout
        >
            Login fehlgeschlagen
            <v-btn
                    dark
                    text
                    @click="showError = false"
            >
                Schließen
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import * as firebase from "firebase/app";
    import "firebase/auth";
    export default {
        name: "Login",
        data: () => ({
            password: "",
            email: "",
            showError: false,
            errorTimeout: 2000
        }),
        methods: {
            login() {
                firebase
                    .auth()
                    .signInWithEmailAndPassword(this.email, this.password)
                    .catch(() => {
                        this.showError = true;
                        this.password = "";
                    });
            }
        }
    }
</script>

<style scoped>
</style>
